import React, { useRef, useState, useEffect } from "react";
import HeroSlider from "../components/UI/HeroSlider";
import Helmet from "../components/Helmet/Helmet";
import { Container, Row, Col, Button } from "reactstrap";
import AboutSection from "../components/UI/AboutSection";
import CarItem from "../components/UI/CarItem";

const Home = ({ cars }) => {
  const aboutSectionRef = useRef(null);

  const scrollToAboutSection = () => {
    aboutSectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Helmet title="Home">
      <section className="p-0 hero__slider-section">
        <HeroSlider />
        <div className="text-center mt-4">
          <Button color="primary" onClick={scrollToAboutSection}>
            Conócenos
          </Button>
        </div>
      </section>

      <section ref={aboutSectionRef}>
        <AboutSection />
      </section>

      <section>
        <Container>
          <Row>
            <Col lg="12" className="text-center mb-5">
              <h2 className="section__title">Nuestros coches</h2>
            </Col>

            {cars.map((item) => (
              <CarItem item={item} key={item.id} />
            ))}
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Home;
